import i18n from "i18next";

import { HazardIdEnum, PolicyDetails, LocationRiskAssessment, PageTabs } from "../hazardIdEnum";
import {
  getLandslideValue,
  getLandslideRatingAndLevel,
  getRainfallXDayValue,
  getRainfallRatingAndLevel,
} from "../../../lib/getRainfallData";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const rainFallColors = [
  "#8F0000",
  "#C80001",
  "#FE0100",
  "#FF9400",
  "#FBC500",
  "#F9F602",
  "#B5E700",
  "#57D006",
  "#02B331",
  "#028C4E",
  "#028414",
  "#C0C0C0",
  "#FFFFFF",
].reverse();

const localLandslideEvaluator = async (lat: number, lng: number) => {
  const landslideValue = await getLandslideValue(lat, lng);
  const landslideRatingAndLevel = getLandslideRatingAndLevel(landslideValue);
  return {
    value: landslideValue,
    ...landslideRatingAndLevel,
    maxRateAccepted: 3,
  };
};

const localRainFallOneDayEvaluator = async (lat: number, lng: number) => {
  const landslideValue = await getRainfallXDayValue(lat, lng, 1);
  const landslideRatingAndLevel = getRainfallRatingAndLevel(landslideValue);
  return {
    value: landslideValue,
    ...landslideRatingAndLevel,
    maxRateAccepted: 13,
  };
};

const localRainFallSevenDayEvaluator = async (lat: number, lng: number) => {
  const landslideValue = await getRainfallXDayValue(lat, lng, 7);
  const landslideRatingAndLevel = getRainfallRatingAndLevel(landslideValue);
  return {
    value: landslideValue,
    ...landslideRatingAndLevel,
    maxRateAccepted: 13,
  };
};

const localEarthquakeMagnitudeEvaluator = async (lat: number, lng: number) => {
  return {
    value: 0,
    rating: 0,
    level: "notAvailable",
    maxRateAccepted: 3,
  };
};

export const getWarningHazardsList = (): Hazard[] => [
  /*
  {
    cysId: HazardIdEnum.WarningLandslide,
    name: "Warning Landslide",
    permissions: ["CYS_NOWCAST_LANDSLIDE_GLOBAL_NASA"],
    colorRange: ["#ececec", "#feff73", "#d63031"],

    description: i18n.t("warningExplained.landslideNowcast"),
    label: `${i18n.t("riskAssessment.landslideNowcast")} (NASA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
    evaluateByFrontend: localLandslideEvaluator,
  },
  {
    cysId: HazardIdEnum.WarningRainfall1Day,
    name: "Warning Rainfall 1 Day",
    permissions: ["CYS_NOWCAST_1DAYRAINFALL_EUR_NASA"],
    colorRange: rainFallColors,

    description: i18n.t("warningExplained.oneDayAccumulatedRainfall"),
    label: `${i18n.t("riskAssessment.oneDayAccumulatedRainfall")} (NASA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
    evaluateByFrontend: localRainFallOneDayEvaluator,
  },
  {
    cysId: HazardIdEnum.WarningRainfall7Day,
    name: "Warning Rainfall 7 Day",
    permissions: ["CYS_NOWCAST_7DAYRAINFALL_EUR_NASA"],
    colorRange: rainFallColors,

    description: i18n.t("warningExplained.sevenDayAccumulatedRainfall"),
    label: `${i18n.t("riskAssessment.sevenDayAccumulatedRainfall")} (NASA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
    evaluateByFrontend: localRainFallSevenDayEvaluator,
  },
*/
  {
    cysId: HazardIdEnum.EarthquakeMagnitude,
    name: "Earthquake Magnitude",
    // permissions: ["CYS_RISK_EARTHQUAKEMAG_ITA_USGS"],
    permissions: [PermissionIdEnum.EarthquakeMagnitude],
    colorRange: ["white", "red"],
    description: i18n.t("riskExposureMapExplained.earthquakeMagnitude"),
    label: `${i18n.t("riskAssessment.earthquakeMagnitude")} (INGV)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
    evaluateByFrontend: localEarthquakeMagnitudeEvaluator,
  },
];
